import React, { useEffect, useState } from "react";
import { InfoPersonasHE } from "./typesAsignarCur";
import { Table, Button, Input, PaginationItem, PaginationLink, Pagination, Row, Col, Label } from "reactstrap";
import { ReactComponent as IconoExcel } from "../../../../assets/icons/HorasExtras/Excel.svg";
import { obtenerReporteExcelPHEasignacionFecha, obtenerReporteExcelPHEporPagar } from "./FunctionsAsignarCur";
import ModalCargando from "../../../Varios/ModalCargando";
import { showAlert } from "../Parametros Horas Extras/Actividades/ActividadesHorasExtras";


type PropsTablaAsignacionCUR = {
    contenidoInfo: InfoPersonasHE[],
    SeleccionFilas: { [key: number]: InfoPersonasHE},
    estadoPantalla: string,
    CurPreferencial: number | null,
    statemes: Date | null,
    CurporDefaultAF: number,
    CurporDefaultPP: number,
    onSelectionChange: (selected: { [key: number]: any }) => void
}

export default function TableAsignacionCur(props: PropsTablaAsignacionCUR) {
    const {  CurporDefaultAF, CurporDefaultPP, CurPreferencial, estadoPantalla, SeleccionFilas, statemes } = props;

    const [contenidoSeleccionado, setcontenidoSeleccionado] = useState<{ [key: number]: InfoPersonasHE }>(SeleccionFilas);
    const [loadingAccion, setloadingAccion] = useState<boolean>(false);
    const [curPresentable, setcurPresentable] = useState<number | null>(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    

    const [stateContenido, setstateContenido] = useState(props.contenidoInfo)

    useEffect(() => {
      setstateContenido(props.contenidoInfo)
    }, [props.contenidoInfo])
    

    const contenidoInfo = [...stateContenido]

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    let currentRows = contenidoInfo.slice(indexOfFirstRow, indexOfLastRow);

    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(contenidoInfo.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    };

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };
    const stylesInput: React.CSSProperties = {
        textAlign: 'center',
        width: '90%',
        textSizeAdjust: 'auto',
        fontFamily: "Roboto",
        fontSize: "1.0em",
        paddingLeft: "20px",
    };
    
    useEffect(() => {
        contenidoInfo.map((cf) => {
            var cur = cf.infoSolicitud.numeroCur;
            setcurPresentable(cur)
        })
    }, []);

    async function ReporteExcel() {
        if (estadoPantalla == "PP" && CurPreferencial) {
            setloadingAccion(true);
            await obtenerReporteExcelPHEporPagar(CurPreferencial);
            setloadingAccion(false);
        }
        else if (estadoPantalla == "AF" && CurPreferencial) {
            setloadingAccion(true);
            await obtenerReporteExcelPHEasignacionFecha(CurPreferencial);
            setloadingAccion(false);
        } else {
            showAlert("ha sucedido un inconveniente con el numero CUR", false);
        }
    };
        
    const handleSelectAll = () => {
        let nuevaSeleccion = { ...contenidoSeleccionado }

        const elementos = contenidoInfo.every((id) => contenidoSeleccionado[id.infoSolicitud.idSolicitud]);

        
        if (elementos) {
            contenidoInfo.forEach((contenido) => {
                delete nuevaSeleccion[contenido.infoSolicitud.idSolicitud]
                setcontenidoSeleccionado(nuevaSeleccion);
                props.onSelectionChange(nuevaSeleccion);
            })
        }
        else {
            contenidoInfo.forEach((contenido) => {
                
                nuevaSeleccion[contenido.infoSolicitud.idSolicitud] = {
                    infoPersona: {
                        identificacion: contenido.infoPersona.identificacion,
                        nombres: contenido.infoPersona.nombres,
                        regimen: contenido.infoPersona.regimen,
                        rmu: contenido.infoPersona.rmu,
                        unidad: contenido.infoPersona.unidad
                    },
                    infoSolicitud: {
                        idSolicitud: contenido.infoSolicitud.idSolicitud,
                        estado: contenido.infoSolicitud.estado,
                        mesSolicitud: contenido.infoSolicitud.mesSolicitud,
                        heExtraordinaria: contenido.infoSolicitud.heExtraordinaria,
                        heSumplementarias: contenido.infoSolicitud.heSumplementarias,
                        tHorasExtras: contenido.infoSolicitud.tHorasExtras,
                        vHeExtraordinaria: contenido.infoSolicitud.vHeExtraordinaria,
                        vHeSuplementarias: contenido.infoSolicitud.vHeSuplementarias,
                        tvHorasExtras: contenido.infoSolicitud.tvHorasExtras,
                        numeroCur: contenido.infoSolicitud.numeroCur,
                        fechaCur: contenido.infoSolicitud.fechaCur,
                        fechaPago: contenido.infoSolicitud.fechaPago
                    }
                }
            })
            setcontenidoSeleccionado(nuevaSeleccion);
            props.onSelectionChange(nuevaSeleccion);
        }

    };

    const seleccion = currentRows.every((id) => contenidoSeleccionado[id.infoSolicitud.idSolicitud]);

    const handleSelectOne = (cont) => {
        let isDeselecting = !!contenidoSeleccionado[cont.infoSolicitud.idSolicitud];

        if (isDeselecting) {
            const nuevaSeleccion = { ...contenidoSeleccionado };
            delete nuevaSeleccion[cont.infoSolicitud.idSolicitud];
            setcontenidoSeleccionado(nuevaSeleccion);
            props.onSelectionChange(nuevaSeleccion);
            return;
        }
        const nuevaSeleccion = { ...contenidoSeleccionado }
        nuevaSeleccion[cont.infoSolicitud.idSolicitud] = {
            infoPersona: {
                identificacion: cont.infoPersona.identificacion,
                nombres: cont.infoPersona.nombres,
                regimen: cont.infoPersona.regimen,
                rmu: cont.infoPersona.rmu,
                unidad: cont.infoPersona.unidad
            },
            infoSolicitud: {
                idSolicitud: cont.infoSolicitud.idSolicitud,
                estado: cont.infoSolicitud.estado,
                mesSolicitud: cont.infoSolicitud.mesSolicitud,
                heExtraordinaria: cont.infoSolicitud.heExtraordinaria,
                heSumplementarias: cont.infoSolicitud.heSumplementarias,
                tHorasExtras: cont.infoSolicitud.tHorasExtras,
                vHeExtraordinaria: cont.infoSolicitud.vHeExtraordinaria,
                vHeSuplementarias: cont.infoSolicitud.vHeSuplementarias,
                tvHorasExtras: cont.infoSolicitud.tvHorasExtras,
                numeroCur: cont.infoSolicitud.numeroCur,
                fechaCur: cont.infoSolicitud.fechaCur,
                fechaPago: cont.infoSolicitud.fechaPago
            }
        }
        setcontenidoSeleccionado(nuevaSeleccion);
        props.onSelectionChange(nuevaSeleccion);
    };

    useEffect(() => {
        setcontenidoSeleccionado({});

    }, [CurPreferencial, statemes])

    return (
        <>
            <Row>
                <Col md="3">
                    <div className="d-flex align-items-center justify-content-start">
                        <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                        <select
                            id="rowsPerPageSelect"
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="custom-select custom-select-sm mr-2"
                            style={{ width: 'auto' }}
                        >
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                        </select>
                        <Label className="mb-0">filas</Label>
                    </div>
                </Col>
                {estadoPantalla !== "SA" && estadoPantalla !== "EC" && (
                    <Col md="8">
                        <div style={{ marginTop: -15 }} className="d-flex justify-content-end">
                            <Button
                                onClick={() => {
                                    ReporteExcel();
                                }}
                                className="btn-Excel">
                                <div className="containerBotonImprimir">
                                    <div>Exportar a Excel</div>
                                    <IconoExcel className="iconBotonImprimir" />
                                </div>
                            </Button>
                        </div>
                    </Col>
                )}
            </Row>
            <div className={"table-responsive"} /*contenedor para hacer la tabla desplazable*/>
                <Table style={stylesInput} className="table_planificacion_he table table-bordered ">
                    <thead className="cabeceras_tabla_servidores_act_he">
                        <tr className="borde_cabeceras_he">
                            <th>#</th>
                            <th colSpan={1} className="centrado">
                                <div> Cedula </div>
                            </th>
                            <th colSpan={1} className="centrado"> Nombres </th>
                            <th colSpan={1} className="centrado"> Unidad </th>
                            <th colSpan={1} className="centrado"> Regimen </th>
                            <th colSpan={1} className="centrado"> RMU <br /> vigente </th>
                            <th colSpan={1} className="centrado"> Total Horas <br /> Supl. </th>
                            <th colSpan={1} className="centrado"> Total Horas <br /> Extra. </th>
                            <th colSpan={1} className="centrado"> Total Horas <br /> Extras </th>
                            <th colSpan={1} className="centrado"> Valor Horas <br /> Supl. </th>
                            <th colSpan={1} className="centrado"> Valor Horas <br /> Extra. </th>
                            <th colSpan={1} className="centrado"> Valor a recibir </th>
                            <th colSpan={1} className="centrado"> Fecha de CUR </th>
                            <th colSpan={1} className="centrado"> CUR </th>
                            <th colSpan={1} className="centrado"> Fecha de Pago </th>
                            {estadoPantalla != "PP" && (
                                <th colSpan={1} className="centrado"> seleccionar <br /> <input
                                    type="checkbox"
                                    checked={seleccion}
                                    onChange={handleSelectAll}
                                    title='Seleccionar todo' />
                                </th>
                            )}
                        </tr>
                    </thead>
                    {currentRows.map((cont, i) => {
                        const globalIndex = indexOfFirstRow + i + 1
                        return (
                            <React.Fragment key={i}>
                                <tbody>
                                    <tr className='rows_tabla_planificacion_he'>
                                        <td >
                                            <div className='text-right pr-1'>
                                                {globalIndex}
                                            </div>
                                        </td>
                                        <td className='centrado'>{cont.infoPersona.identificacion}</td>
                                        <td className='centrado'>
                                            <div style={{ textAlign: "left" }}>
                                                {cont.infoPersona.nombres}
                                            </div>
                                        </td>
                                        <td className='centrado'> {cont.infoPersona.unidad} </td>
                                        <td className='centrado'> {cont.infoPersona.regimen} </td>
                                        <td className='centrado'> {cont.infoPersona.rmu.toFixed(2)} </td>
                                        <td className='centrado'> {cont.infoSolicitud.heSumplementarias} </td>
                                        <td className='centrado'> {cont.infoSolicitud.heExtraordinaria} </td>
                                        <td className='centrado'> {cont.infoSolicitud.tHorasExtras} </td>
                                        <td className='centrado'> {cont.infoSolicitud.vHeSuplementarias?.toFixed(2)} </td>
                                        <td className='centrado'> {cont.infoSolicitud.vHeExtraordinaria?.toFixed(2)} </td>
                                        <td className='centrado'> {cont.infoSolicitud.tvHorasExtras?.toFixed(2)} </td>
                                        <td className='centrado'> {cont.infoSolicitud.fechaCur} </td>
                                        <td className='centrado'> {cont.infoSolicitud.numeroCur} </td>
                                        <td className='centrado'> {cont.infoSolicitud.fechaPago} </td>
                                        {estadoPantalla != "PP" && (
                                            <td className='centrado'>
                                                <input type="checkbox"
                                                    checked={!!contenidoSeleccionado[cont.infoSolicitud.idSolicitud]}
                                                    onChange={() => handleSelectOne(cont)}
                                                    title='Seleccionar persona' />
                                            </td>
                                        )}
                                    </tr>
                                </tbody>
                            </React.Fragment>
                        )
                    })}
                </Table>
            </div>
            <Col xl={11}>
                <Pagination size="sm" className="pagination_planificacion_he">
                    {renderPageNumbers}
                </Pagination>
            </Col>
            
            <ModalCargando
                show={loadingAccion === true}
                textoCargando='Generando Reporte'
                size='md'
                onClose={() => setloadingAccion(false)}
            />
        </>
    )
}